import { useTranslation } from 'react-i18next';
import { date, object, string, number } from 'yup';

import { yupFile } from '@utils/yup';

import { FormValues } from './type';

export const useFormValues = () => {
  const values: FormValues = {
    insurerId: '',
    healthPlanId: '',
    userId: '',
    thirdPartyAdminEmail: '',
    activationDate: '',
    adminFeeAmount: '',
    note: '',
    proof: undefined,
  };
  return values;
};

export const useFormSchema = () => {
  const { t } = useTranslation();
  return object({
    insurerId: number().required(t('validation:required')),
    healthPlanId: number().required(t('validation:required')),
    userId: number().required(t('validation:required')),
    thirdPartyAdminEmail: string().email(t('validation:email')).optional(),
    activationDate: date().required(t('validation:required')),
    adminFeeAmount: number().required(t('validation:required')),
    note: string().optional(),
    proof: yupFile(),
  });
};
